
import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/ui-components/PageTitle/PageTitle.vue';

@Component({
  name: 'HelpPage',
  components: {
    PageTitle
  },
})
export default class HelpPage extends Vue {
  
}
